import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePlanInfo } from '../hooks/usePlanInfo';
import { LoadingSpinner } from './ui/LoadingSpinner';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { data: planInfo, isLoading } = usePlanInfo();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (!planInfo?.can_access_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;




